// src/authConfig.js

export const msalConfig = {
 // redirectUri: window.location.origin,
  auth: {
    clientId: '7e77a6e7-5de2-4eaa-a338-9eedee068fe6',
    authority: 'https://login.microsoftonline.com/d3746fd5-cb63-4258-bdd6-efa8d9706aff',
    redirectUri: 'https://central.vdcapp.in/dashboard', // ✅ Must match Azure config
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  }
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'user.read'],
};


